<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     返回
  +---------------------------------------------------------------------------------------
-->
<template>
  <div role="button" class="mr-sm text-black flex-center" @click="back">
    <i class="el-icon-back font-lg" />
  </div>
</template>

<script>
export default {
  name: "FBack",

  data() {
    return {
    }
  },

  methods: {
    back() {
      this.$router.go(-1)
    },
  }
}
</script>
